export default {
  apiKey: 'AIzaSyAmyePdUHeJ93MgcwcYYKPcAwanYN6oYG8',
  authDomain: 'vuedemo-2c254.firebaseapp.com',
  databaseURL: 'https://vuedemo-2c254.firebaseio.com',
  projectId: 'vuedemo-2c254',
  storageBucket: 'vuedemo-2c254.appspot.com',
  messagingSenderId: '515184925658'
}



// WEBPACK FOOTER //
// ./src/components/fireBaseConfig.js